import React from "react";

/**
 * Pulsing red "LIVE NOW" badge. Used on:
 *   - The live-service tile on Landing (public) and Dashboard (members)
 *   - Over the YouTube iframe on `/public/live`
 *
 * Sizes:
 *   - `tile`: compact overlay for grid tiles (top-right corner)
 *   - `banner`: full-width ribbon on the player card
 *
 * Uses CSS animation `live-pulse` (defined in index.css) — tiny +
 * self-contained so there's no `framer-motion` cost on every page.
 */
export default function LiveBadge({
  size = "tile",
  label,
  "data-testid": testId = "live-badge",
}) {
  const text = label || "LIVE NOW";
  if (size === "banner") {
    return (
      <div
        data-testid={testId}
        className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-600 text-white text-xs font-bold tracking-wide shadow-lg"
      >
        <span className="relative flex h-2.5 w-2.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-300 opacity-75" />
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-white" />
        </span>
        {text}
      </div>
    );
  }
  // tile overlay
  return (
    <div
      data-testid={testId}
      className="absolute top-1.5 right-1.5 inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-red-600 text-white text-[9px] font-bold tracking-wide shadow"
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-300 opacity-75" />
        <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-white" />
      </span>
      {text}
    </div>
  );
}
